import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import { useFormikContext } from 'formik'
import { useState } from 'react'
import { BsArrowUp, BsPrinter } from 'react-icons/bs'
import { currencyMask } from '../../../../utils/masks'
import AutoComplete from '../../../../components/AutoComplete/AutoComplete'
import CurrencyField from '../../../../components/CurrencyField/CurrencyField'
import { setWarning } from '../../../../components/alerts'
import { useCheckout } from './CheckoutContext'
import BotaoEstornos from '../../components/BotaoEstornos'

const ResumoFinal = ({ onImprimir, onSalvarRascunho }) => {
  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    submitForm,
    setSubmitting,
    handleChange,
  } = useFormikContext()
  const { isFinalizado, vlAbertoPdv, vlPagoPdv, getCalculos } = useCheckout()
  const [totalEstornado, setTotalEstornado] = useState(0)

  const isDisabled = isSubmitting || isFinalizado
  const { totalGeral, saldoProposta, totalDevedor, valorTotalTabelaBase } =
    getCalculos(values)
  const totalPago = (values.formasPagamento || []).reduce(
    (acumulador, formaPagamento) =>
      acumulador + Number(formaPagamento?.vlPago || 0),
    0,
  )
  const valorDesconto = Number(values.vlDesconto || 0)
  const totalComDesconto = Math.max(0, totalGeral - valorDesconto)
  const isCampoFinanceiroDisabled = isDisabled || totalComDesconto <= 0

  return (
    <Paper
      sx={{
        borderRadius: 3,
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ px: 2, pt: 2, pb: 1 }}>
        <Typography
          align="center"
          sx={{ fontWeight: 700, fontSize: 18, mb: 2 }}
        >
          Resumo Final
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <BsArrowUp
            size={10}
            style={{
              color: 'red',
              fontSize: 18,
              marginRight: 6,
              flexShrink: 0,
            }}
          />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Saldo Proposta
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, ml: 2 }}>
            R$ {currencyMask(saldoProposta)}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <BsArrowUp
            size={10}
            style={{
              color: 'red',
              fontSize: 18,
              marginRight: 6,
              flexShrink: 0,
            }}
          />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Aberto no PDV
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, ml: 2 }}>
            R$ {currencyMask(vlAbertoPdv)}
          </Typography>
        </Box>

        <Divider sx={{ my: 1.5 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Typography
            variant="body1"
            sx={{ flex: 1, fontWeight: 300, fontSize: 16 }}
          >
            SubTotal
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 700, fontSize: 16 }}>
            R$ {currencyMask(valorTotalTabelaBase)}
          </Typography>
        </Box>

        {valorDesconto > 0 && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
            <Typography variant="body2" sx={{ flex: 1, color: 'success.main' }}>
              Desconto
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 700, ml: 2, color: 'success.main' }}
            >
              - R$ {currencyMask(valorDesconto)}
            </Typography>
          </Box>
        )}

        <Divider sx={{ my: 1.5 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Typography
            variant="body1"
            sx={{ flex: 1, fontWeight: 700, fontSize: 16 }}
          >
            Total a Pagar
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 700, fontSize: 16 }}>
            R$ {currencyMask(totalComDesconto)}
          </Typography>
        </Box>

        <Divider sx={{ my: 1.5 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <BsArrowUp
            size={10}
            style={{
              color: 'green',
              marginRight: 6,
              flexShrink: 0,
            }}
          />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Total Pago no PDV
          </Typography>
          <Typography
            variant="body2"
            color={'green'}
            sx={{ fontWeight: 700, ml: 2 }}
          >
            R$ {currencyMask(vlPagoPdv)}
          </Typography>
        </Box>

        <Box
          sx={{
            bgcolor: isFinalizado ? '#e8f5e9' : '#fff0f0',
            borderRadius: 1,
            p: isFinalizado ? 3 : 1.5,
            textAlign: 'center',
            mb: 2,
          }}
        >
          {isFinalizado ? (
            <>
              <Typography
                sx={{ fontWeight: 700, fontSize: 28, color: 'green' }}
              >
                PAGO (R$ {currencyMask(totalPago)})
              </Typography>
              {totalEstornado > 0 && (
                <>
                  <Typography>
                    Estornado: R$ {currencyMask(totalEstornado)}
                  </Typography>
                  <Typography fontWeight={700}>
                    Valor líquido pago: R${' '}
                    {currencyMask(Math.max(0, totalPago - totalEstornado))}
                  </Typography>
                </>
              )}
              <BotaoEstornos
                codigo="CtrlCheckout"
                idAtendimento={values.idAtendimento}
                habilitado={isFinalizado}
                temPagamento={totalPago > 0}
                onTotalEstornado={setTotalEstornado}
              />
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: 22,
                  color: 'red',
                }}
              >
                R$ {currencyMask(totalDevedor)}
              </Typography>
              <Typography
                variant="caption"
                sx={{ fontWeight: 600, color: 'red' }}
              >
                Saldo Devedor
              </Typography>
            </>
          )}
        </Box>
      </Box>

      <Divider />

      <Box sx={{ px: 2, py: 2 }}>
        <AutoComplete
          InputLabelProps={{ shrink: true }}
          label="Forma de Pagamento"
          metodo="buscaFormaPagamento"
          multiple
          size="small"
          filterFunction={() => true}
          filterSelectedOptions={false}
          value={values?.acFormaPagamento || []}
          disabled={isCampoFinanceiroDisabled}
          onChange={(_, val) => {
            const opcoesSelecionadas = val?.map((item) => {
              const idFormaPagamento = item?.[0]?.[0]
              const unic = item?.[0]?.[1] || crypto.randomUUID()

              return [[idFormaPagamento, unic], ...item.slice(1)]
            })
            const valorTotalPagamento =
              totalDevedor +
              (values?.formasPagamento || []).reduce(
                (acumulador, formaPagamento) =>
                  acumulador + Number(formaPagamento?.vlPago || 0),
                0,
              )
            let valorJaDistribuido = 0
            const valorTratado = opcoesSelecionadas?.map((item) => {
              const idFormaPagamento = item?.[0]?.[0]
              const unic = item?.[0]?.[1]
              const existente = values?.formasPagamento?.find(
                (v) =>
                  v.idFormaPagamento === idFormaPagamento && v.unic === unic,
              )
              const vlPago = existente
                ? Number(existente.vlPago || 0)
                : Math.max(0, valorTotalPagamento - valorJaDistribuido)

              valorJaDistribuido += vlPago

              return {
                idFormaPagamento,
                vlPago,
                qtParcelas: existente ? existente.qtParcelas : item?.[4],
                isParcelas: existente ? existente.isParcelas : item?.[3],
                unic,
              }
            })
            setFieldValue('formasPagamento', valorTratado)
            setFieldValue('acFormaPagamento', opcoesSelecionadas)
          }}
          textFieldProps={{
            error: !!errors?.acFormaPagamento,
            helperText: errors?.acFormaPagamento,
            variant: 'outlined',
            size: 'small',
          }}
        />

        {values?.acFormaPagamento?.map((item, index) => (
          <Grid
            container
            key={item?.[0]?.[1] || index}
            spacing={1}
            alignItems="center"
            sx={{ mt: 1 }}
          >
            <Grid item xs={item?.[3] ? 7 : 12}>
              <CurrencyField
                fullWidth
                variant="outlined"
                margin="dense"
                InputLabelProps={{ shrink: true }}
                label={item?.[1]}
                disabled={isCampoFinanceiroDisabled}
                size="small"
                value={
                  values?.formasPagamento?.find(
                    (v) => v.unic === item?.[0]?.[1],
                  )?.vlPago || 0
                }
                onChange={(val) => {
                  const totalOutrasFormas =
                    values?.formasPagamento
                      ?.filter((v) => v.unic !== item?.[0]?.[1])
                      ?.reduce(
                        (acumulador, formaPagamento) =>
                          acumulador + Number(formaPagamento?.vlPago || 0),
                        0,
                      ) || 0
                  const valorMaximo = Math.max(
                    0,
                    totalGeral -
                      Number(values?.vlDesconto || 0) -
                      totalOutrasFormas,
                  )

                  if (Number(val || 0) > valorMaximo) {
                    return setWarning(
                      'O valor pago não pode ultrapassar o saldo devedor',
                    )
                  }

                  setFieldValue(
                    'formasPagamento',
                    values?.formasPagamento?.map((v) =>
                      v?.unic === item?.[0]?.[1] ? { ...v, vlPago: val } : v,
                    ),
                  )
                }}
                error={!!errors?.formasPagamento?.[index]?.vlPago}
              />
            </Grid>
            {item?.[3] && (
              <Grid item xs={5}>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  margin="dense"
                  label="Parcelas"
                  size="small"
                  disabled={isCampoFinanceiroDisabled}
                  value={
                    values?.formasPagamento?.find(
                      (v) => v.unic === item?.[0]?.[1],
                    )?.qtParcelas
                  }
                  onChange={(e) => {
                    const val = e?.target?.value
                    setFieldValue(
                      'formasPagamento',
                      values?.formasPagamento?.map((v) =>
                        v?.unic === item?.[0]?.[1]
                          ? {
                              ...v,
                              qtParcelas: val ? Number(val) : '',
                            }
                          : v,
                      ),
                    )
                  }}
                  error={!!errors?.formasPagamento?.[index]?.qtParcelas}
                />
              </Grid>
            )}
          </Grid>
        ))}
      </Box>

      <Divider />

      <Box sx={{ px: 2, py: 2 }}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              variant="outlined"
              margin="dense"
              InputLabelProps={{ shrink: !!values?.prDesconto }}
              label="Porcentagem (%)"
              type="number"
              size="small"
              value={values?.prDesconto}
              disabled={isCampoFinanceiroDisabled}
              onChange={(e) => {
                const pr = parseFloat(e.target.value)
                const vlCalculado = (pr / 100) * valorTotalTabelaBase
                setFieldValue('prDesconto', pr || '')
                setFieldValue('vlDesconto', vlCalculado)
                setFieldValue('vlTotal', valorTotalTabelaBase - vlCalculado)
              }}
              onFocus={(e) =>
                e.target.value === '0' && setFieldValue('prDesconto', '')
              }
              error={touched?.prDesconto && !!errors.prDesconto}
              helperText={touched?.prDesconto && errors.prDesconto}
            />
          </Grid>
          <Grid item xs={6}>
            <CurrencyField
              fullWidth
              variant="outlined"
              margin="dense"
              label="Desconto (R$)"
              size="small"
              disabled={isCampoFinanceiroDisabled}
              value={values?.vlDesconto || 0}
              onChange={(v) => {
                const vl = parseFloat(v)
                const prCalculado =
                  valorTotalTabelaBase > 0
                    ? (vl / valorTotalTabelaBase) * 100
                    : 0
                setFieldValue('vlDesconto', vl)
                setFieldValue('prDesconto', prCalculado.toFixed(2))
                setFieldValue('vlTotal', valorTotalTabelaBase - vl)
              }}
              helperText={
                touched?.vlDesconto && errors.vlDesconto
                  ? errors.vlDesconto
                  : ''
              }
              error={touched?.vlDesconto && !!errors.vlDesconto}
            />
          </Grid>
          <Divider />
          <Grid item xs={12}>
            <TextField
              label="Observação"
              fullWidth
              size="small"
              multiline
              rows={3}
              name="dsObservacoes"
              value={values.dsObservacoes || ''}
              onChange={handleChange}
              disabled={isSubmitting || isFinalizado}
            />
          </Grid>
        </Grid>
      </Box>

      <Divider />

      <Box
        sx={{
          px: 2,
          py: 1.5,
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <IconButton
          title="Imprimir PDF"
          onClick={() => onImprimir(values, setSubmitting)}
          disabled={isSubmitting}
        >
          <BsPrinter />
        </IconButton>
        <Button
          color="inherit"
          variant="outlined"
          disabled={isDisabled}
          onClick={() => onSalvarRascunho(values, setSubmitting)}
          sx={{ textTransform: 'none', height: 45 }}
        >
          Salvar rascunho
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={isDisabled}
          onClick={!isFinalizado ? submitForm : undefined}
          sx={{
            textTransform: 'none',
            fontWeight: 'bold',
            height: 45,
            px: 3,
          }}
        >
          {isFinalizado ? 'Finalizado' : 'Finalizar CheckOut'}
        </Button>
      </Box>
    </Paper>
  )
}

export default ResumoFinal
